const SwiperDamonBracesGallery = {
	init: () => {
		window.addEventListener('load', () => {


			if (typeof Swiper !== typeof undefined) {

				new Swiper('#before-and-after-gallery', {
					slidesPerView: 1,
					spaceBetween: 0,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints: {
						// window width is >=
						768: {
							slidesPerView: 2,
							spaceBetween: 20
						},
						992: {
							slidesPerView: 3,
							spaceBetween: 20
						},
					}
				});

			}


		}, false);
	}
}


SwiperDamonBracesGallery.init()
